/**
 * Pricing Display Tabs Component
 * Switches between Price summary and Financing calculator
 *
 * @package
 */

import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import PriceSummary from './PriceSummary';
import VatToggle from './VatToggle';
// import FinancingCalculator from './FinancingCalculator'; // Temporarily hidden

const PricingDisplayTabs = ( {
	selectedBaseModel,
	selectedProducts,
	vatMode,
	onVatToggle,
	workshopHourlyRate = 0,
	taxRate = 0,
	quantities = {},
} ) => {
	const [ activeTab, setActiveTab ] = useState( 'price' );

	const tabs = [
		{ value: 'price', label: __( 'Price', 'at-vehicle-configurator' ) },
		// { value: 'financing', label: __( 'Financing', 'at-vehicle-configurator' ) }, // Temporarily hidden
	];

	return (
		<div className="configurator-pricing-type-tabs">
			{ tabs.length > 1 && (
				<div className="configurator-pricing-type-tab-buttons" role="tablist">
					{ tabs.map( tab => (
						<button
							key={ tab.value }
							type="button"
							role="tab"
							className={ `configurator-pricing-type-tab ${ activeTab === tab.value ? 'active' : '' }` }
							onClick={ () => setActiveTab( tab.value ) }
							aria-selected={ activeTab === tab.value }
							aria-controls={ `configurator-${ tab.value }-panel` }
							aria-label={ tab.label }
						>
							{ tab.label.toUpperCase() }
						</button>
					) ) }
				</div>
			) }
			<div className="configurator-pricing-display-content">
				{ activeTab === 'price' && (
					<div
						id="configurator-price-panel"
						role="tabpanel"
						aria-labelledby="price-tab"
					>
						<PriceSummary
							selectedBaseModel={ selectedBaseModel }
							selectedProducts={ selectedProducts }
							vatMode={ vatMode }
							workshopHourlyRate={ workshopHourlyRate }
							taxRate={ taxRate }
							quantities={ quantities }
						/>
					</div>
				) }
			</div>
			<VatToggle vatMode={ vatMode } onToggle={ onVatToggle } />
		</div>
	);
};

export default PricingDisplayTabs;
